import styles from './SelectedAltitude.module.css'
const SelectedAltitude = ({ currPointHeight }) => {
    return (
        currPointHeight !== null?
            <div className={styles.selAlt}>
                Selected Altitude from DTM: {currPointHeight.toFixed(4)} m
            </div> :
            <div className={styles.selAlt} style={{color:"var(--color-danger)"}}>
                {"ERROR('Out of bound Click Detected')"}
            </div>
    )
}

export default SelectedAltitude
